module.exports = __webpack_public_path__ + "static/media/photo-right-second.db2d8d28.png";